import { useIntl } from "react-intl";

const MultiUserAndGroupApprovals = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MultiUserAndGroupApprovals.header",
            defaultMessage: "Multi-user and group approvals"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MultiUserAndGroupApprovals.body",
            defaultMessage:
                "Configure approval workflows based on type of change, associated risk, or procedures set by your change advisory board."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default MultiUserAndGroupApprovals;
